import React from 'react';
import { ReactComponent as Delete } from 'Icons/Sidebar/Delete.svg';
import { ReactComponent as GridLayerIcon } from 'Icons/Header/Canvas/GridLayer.svg';
import { ReactComponent as CustomLayerIcon } from 'Icons/Header/Canvas/CustomLayer.svg';
import { ReactComponent as RandomLayerIcon } from 'Icons/Header/Canvas/RandomLayer.svg';
import { ReactComponent as ProteinLayerIcon } from 'Icons/Header/Canvas/ProteinLayer.svg';
import { ReactComponent as ScreenLayerIcon } from 'Icons/Header/Canvas/ScreenLayer.svg';
import { ReactComponent as SeedingLayerIcon } from 'Icons/Header/Canvas/SeedingLayer.svg';
import { ReactComponent as LinkedLayerIcon } from 'Icons/Header/Canvas/GridLayerGroup.svg';
import './LayersSelection.scss';
import { LayerTypeDTO } from 'business/models/Models';
import { GridLayerTypes } from 'components/commandpanel/Layers/LayersSelectionParent';
import { useLicenseAuthorizeCommand } from 'CustomHooks/useLicenseAuthorizeCommand';
import { getLayerUserAction } from 'utils/Global';
import RMSvgIcon from '../CommonComponents/RMSvgIcon';
type LayersSelectionProps = {
  text: string;
  active?: boolean;
  type?: number;
  enableDelete?: boolean;
  activeClass: string;
  onClick?: () => void;
  onDeleteLayer?: (id) => void;
  locked?: boolean;
};

export default function LayersSelection({
  type,
  text,
  activeClass,
  active = false,
  enableDelete = true,
  onClick,
  onDeleteLayer,
  locked = false,
}: LayersSelectionProps) {
  const licenseAuthCommand = useLicenseAuthorizeCommand();
  function getLayerIcon() {
    switch (type) {
      case LayerTypeDTO.Grid:
        return <GridLayerIcon id='layerselection-grid-icon' />;
      case LayerTypeDTO.ConditionList:
        return <CustomLayerIcon id='layerselection-custom-icon' />;
      case LayerTypeDTO.Random:
        return <RandomLayerIcon id='layerselection-random-icon' />;
      case LayerTypeDTO.Protein:
        return <ProteinLayerIcon id='layerselection-protein-icon' />;
      case LayerTypeDTO.Seed:
        return <SeedingLayerIcon id='layerselection-seeding-icon' />;
      case LayerTypeDTO.Screen:
        return <ScreenLayerIcon id='layerselection-screen-icon' />;
      case GridLayerTypes.SUBGRID:
        return <LinkedLayerIcon id='layerselection-linked-icon' />;
      case LayerTypeDTO.Fragment:
        return (
          <RMSvgIcon
            id="layerselection-fragment-icon"
            data-testid="layerselection-fragment-icon"
            name="FragmentScreen"
            style={{ fill: 'black' }}
          />
        );
      default:
        return <CustomLayerIcon />;
    }
  }

  const deleteLayer = () => {
    licenseAuthCommand(onDeleteLayer, getLayerUserAction(type))();
  };

  const identifier = text.toLowerCase().replaceAll(' ', '');
  return (
    <div
      id="layersselection-wrapper"
      data-testid="layersselection-wrapper"
      className={`layer-selection-parent text-align-center flex flex-column flex-y-center justify-content-start ${
        active && activeClass
      }`}
      onClick={onClick}
    >
      {active && enableDelete && (
        <Delete
          id="layersselection-delete-button"
          data-testid="layersselection-delete-button"
          onClick={locked ? null : deleteLayer}
          className={locked ? 'delete-button-disabled' : 'delete-button'}
        />
      )}
      <div
        id="layerselection-getlayer-icon"
        data-testid="layerselection-getlayer-icon"
        className="layer-selection-icon"
      >
        {getLayerIcon()}
      </div>
      <div
        id={`layerselection-layer-text-${identifier}`}
        data-testid={`layerselection-layer-text-${identifier}`}
        className="layer-selection-text"
      >
        {text}
      </div>
    </div>
  );
}
